module.exports = __webpack_public_path__ + "static/media/6. Paul.90d04086.png";